import PropTypes from "prop-types";
import React from "react";

const LanguageCurrencyChanger = ({
  currency,
  setCurrency,
  currentLanguageCode,
  dispatch
}) => {

  return (
    <div className="language-currency-wrap">
      <div className="same-language-currency language-style">
        <span style={{ textTransform: 'lowercase', fontSize: '12px' }}>
          <a href="https://www.instagram.com/nagatechsi/?hl=en" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-instagram" /> nagatechsi
          </a>
        </span>
      </div>
      <div className="same-language-currency use-style">
        <span style={{ fontSize: '12px' }}>
          <a href="https://www.youtube.com/channel/UCH2JbmEkGJzaKwlNNVCiwYA/featured" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-youtube-play" /> Nagatech Sistem Integrator
          </a>
        </span>
      </div>
      <div className="same-language-currency">
        <p style={{ fontSize: '12px' }}>Call Us (022)63759821</p>
      </div>
    </div>
  );
};

LanguageCurrencyChanger.propTypes = {
  setCurrency: PropTypes.func,
  currency: PropTypes.object,
  currentLanguageCode: PropTypes.string,
  dispatch: PropTypes.func
};

export default LanguageCurrencyChanger;
